import { ThemeState } from '@core/theme/store/states/theme.state';

export const themeState = [ThemeState];
